import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
import homeRouter from "./homeRouter";
const routes = [
  {
    path:'/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: () =>
      import ('../views/home/home'),
    children: homeRouter,
  },
  {
    path: '/login',
    component: () => import('../views/login/login'),
    meta: {
      title: '登录',
      needLogin: false
    }
  },
  {
    path: '/help',
    component: () => import('../views/login/help'),
    meta: {
      title: '帮助中心',
      needLogin: false
    }
  },
  {
    path: '/version',
    component: () => import('../views/login/version'),
    meta: {
      title: '版本更新',
      needLogin: false
    }
  },
  {
    path: '/tiaoz',
    component: () => import('../views/login/tiaoz'),
    meta: {
      title: '跳转中',
      needLogin: false
    }
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
